import { PropTypes } from "prop-types";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { getDecisionMeetings } from "../../../api/meeting/meeting";
import { useQuery } from "react-query";
import moment from "moment";
import { QueryLoader } from "../../Loader";
import { MeetingsList } from "../../MeetingsList";

export default function DecisionMeetings({ id, newDecision = false }) {
	const { axiosPrivate } = useAxiosPrivate();
	const currentDate = new Date();

	// For new decisions, don't make API calls
	const shouldFetchData = !newDecision && id;
	const emptyResult = { isLoading: false, data: [] };

	const { isLoading: isFutureMeetingsLoading, data: futureMeetingsData } = shouldFetchData
		? useQuery(["futureDecisionMeetings", id], () =>
			getDecisionMeetings(
				axiosPrivate,
				id,
				moment().format("YYYY-MM-DD"),
				moment()
					.year(currentDate.getFullYear() + 2)
					.format("YYYY-MM-DD")
			)
		)
		: emptyResult;

	const { isLoading: isOngoingMeetingsLoading, data: ongoingMeetingsData } = shouldFetchData
		? useQuery(["ongoingDecisionMeetings", id], () =>
			getDecisionMeetings(axiosPrivate, id, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"))
		)
		: emptyResult;

	const { isLoading: isArchiveMeetingsLoading, data: archiveMeetingsData } = shouldFetchData
		? useQuery(["archiveDecisionMeetings", id], () =>
			getDecisionMeetings(
				axiosPrivate,
				id,
				moment()
					.year(currentDate.getFullYear() - 3)
					.format("YYYY-MM-DD"),
				moment().format("YYYY-MM-DD")
			)
		)
		: emptyResult;

	return (
		<>
			<h3>Future meetings</h3>
			{isFutureMeetingsLoading ? <QueryLoader /> : <MeetingsList data={futureMeetingsData} />}
			<h3>Ongoing meetings</h3>
			{isOngoingMeetingsLoading ? <QueryLoader /> : <MeetingsList data={ongoingMeetingsData} />}
			<h3>Archive meetings</h3>
			{isArchiveMeetingsLoading ? <QueryLoader /> : <MeetingsList data={archiveMeetingsData} />}
		</>
	);
}

DecisionMeetings.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	newDecision: PropTypes.bool,
};
